import React from 'react';

const GameControls = ({ gameState, onStart, onResume, onReset, onShowGroups, currentGroup }) => {
  const getStartButtonText = () => {
    switch (gameState) {
      case 'playing':
        return 'GAME RUNNING...';
      case 'paused':
        return 'RESUME';
      default:
        return 'START GAME';
    }
  };

  const handleStartClick = () => {
    if (gameState === 'paused') {
      onResume();
    } else {
      onStart();
    }
  };

  const isStartDisabled = gameState === 'playing';

  return (
    <div className="game-controls">
      <div className="controls-main">
        <button 
          className="btn btn-primary" 
          onClick={handleStartClick}
          disabled={isStartDisabled}
          data-state={gameState}
        >
          {getStartButtonText()}
        </button>
        <button 
          className="btn btn-secondary" 
          onClick={onReset}
        >
          RESET
        </button>
      </div>
      
      {currentGroup && (
        <div className="group-info-display">
          <div className="group-badge">
            <span className="group-name">{currentGroup.groupName}</span>
            <div className="player-indicator" style={{ backgroundColor: currentGroup.playerColor }}>
              <span className="lane-number">{currentGroup.laneNumber}</span>
            </div>
          </div>
        </div>
      )}
      
      <div className="controls-secondary">
        <button 
          className="btn btn-outline"
          onClick={onShowGroups}
        >
          {currentGroup ? 'Change Group' : 'Join Group'}
        </button>
      </div>
    </div>
  );
};

export default GameControls;
